module.exports = __webpack_public_path__ + "staticPO/img/payprocess.01ddc00.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payprocess.gif
// module id = vhnh
// module chunks = 1